import { render, staticRenderFns } from "./group_draw.vue?vue&type=template&id=0455eaed&scoped=true"
import script from "./group_draw.vue?vue&type=script&lang=js"
export * from "./group_draw.vue?vue&type=script&lang=js"
import style0 from "./group_draw.vue?vue&type=style&index=0&id=0455eaed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455eaed",
  null
  
)

export default component.exports